import React from "react"

import ImageSelector from "./background/ImageSelector"
import ImageOptions from "./background/ImageOptions"

function BackgroundTab(props) {

    return (
        <div id="tab-background" className="tab tab-active">
            <ImageSelector
                lang={props.lang}
                images={(props.backgrounds) ? props.backgrounds.images : null}
                imageName={(props.backgrounds) ? props.backgrounds.imageName : null}
                defaultImage={(props.backgrounds) ? props.backgrounds.defaultImage : null}
            />
            <ImageOptions lang={props.lang} option={(props.backgrounds) ? props.backgrounds.option : null} />
        </div>
    );
}

export default BackgroundTab;
